import React from 'react';
import './footer.css';
import './footer-polish.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigation = [
    ['Home', '#home'], ['Services', '#services'], ['About', '#about'],
    ['Projects', '#project'], ['Process', '#how-we-work'], ['Team', '#out-team'],
  ];

  return (
    <footer className="footer" id="footer">
      <div className="footer-inner">
        <div className="footer-main">
          <div className="footer-intro">
            <a className="footer-brand" href="#home" aria-label="Kodex Solutions home">
              <img src="/kodexlogo.png" alt="" className="footer-brand-mark" />
              <span className="footer-brand-type"><strong>KODEX</strong><small>solutions</small></span>
            </a>
            <p>Strategy, design and dependable development for digital experiences built around real business goals.</p>
            <a className="footer-cta" href="#contact">Start a project <span aria-hidden="true">→</span></a>
          </div>

          <nav className="footer-nav" aria-label="Footer navigation">
            <h2>Explore</h2>
            <ul>{navigation.map(([label, href]) => <li key={href}><a href={href}>{label}</a></li>)}</ul>
          </nav>

          <div className="footer-contact">
            <h2>Get in touch</h2>
            <a href="mailto:info@kodexsolutions.se">info@kodexsolutions.se</a>
            <a href="tel:+46700484114">+46 70 048 41 14</a>
            <p>Stockholm, Sweden</p>
            <div className="footer-socials" aria-label="Social media">
              <a href="https://www.linkedin.com/in/vande-nikolovski-054213176/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="bx bxl-linkedin" /></a>
              <a href="https://www.facebook.com/vandenikolovski" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="bx bxl-facebook" /></a>
              <a href="https://www.instagram.com/smekiboy/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="bx bxl-instagram-alt" /></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} Kodex Solutions. All rights reserved.</p>
          <a href="mailto:info@kodexsolutions.se?subject=Privacy%20question">Privacy</a>
          <a href="#home">Back to top <span aria-hidden="true">↑</span></a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
